// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 25","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M10.6484 2.07227C10.3905 2.77251 10.25 3.52954 10.25 4.31934C10.25 7.90919 13.1601 10.8193 16.75 10.8193C17.5396 10.8193 18.296 10.6778 18.9961 10.4199C19.0295 12.3578 18.3798 14.3011 17.1738 15.8291L22.5205 21.1758L21.1064 22.5898L15.7598 17.2432C14.312 18.3857 12.4777 19.0693 10.5 19.0693C5.86452 19.0693 2 15.1986 2 10.5693C2 6.33095 5.33492 2.57643 9.58398 2.11816C9.94543 2.07943 10.2568 2.06556 10.6484 2.07227Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M18.0322 3.03613L21.0693 4.31934L18.0322 5.60156L16.75 8.63867L15.4668 5.60156L12.4307 4.31934L15.4668 3.03613L16.75 0L18.0322 3.03613Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-ai-search-filled')
export default class AiSearchFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'ai-search-filled',
    }
  }
}
